import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store';
import {
  clearFilters,
  clearSelectedDetail,
  fetchClienteVendasThunk,
  fetchVendaDetailThunk,
  setCurrentClienteId,
  setFilters,
  setLimit,
  setPage,
} from '../store/slices/cliente-vendas.slice';
import { ClienteVendasFilters } from '../types/cliente-venda';

export const useClienteVendas = (clienteId: string | undefined) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.clienteVendas);

  useEffect(() => {
    dispatch(setCurrentClienteId(clienteId ?? null));
  }, [dispatch, clienteId]);

  const refresh = useCallback(() => {
    if (!clienteId) return Promise.resolve(undefined);
    return dispatch(
      fetchClienteVendasThunk({
        clienteId,
        params: {
          page: state.page,
          limit: state.limit,
          ...state.filters,
        },
      }),
    );
  }, [dispatch, clienteId, state.page, state.limit, state.filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const openDrawer = (id: string) => dispatch(fetchVendaDetailThunk(id));
  const closeDrawer = () => dispatch(clearSelectedDetail());

  return {
    items: state.items,
    page: state.page,
    limit: state.limit,
    total: state.total,
    totalPages: state.totalPages,
    filters: state.filters,
    status: state.status,
    error: state.error,
    setFilters: (filters: ClienteVendasFilters) =>
      dispatch(setFilters(filters)),
    clearFilters: () => dispatch(clearFilters()),
    setPage: (page: number) => dispatch(setPage(page)),
    setLimit: (limit: number) => dispatch(setLimit(limit)),
    refresh,
    selectedDetail: state.selectedDetail,
    detailStatus: state.detailStatus,
    detailError: state.detailError,
    openDrawer,
    closeDrawer,
  };
};
